export default __webpack_public_path__ + "static/sketch-7f588044f91d59d2d8646f2dd60f1486.png";